import buildSimpleStringFilter from '../buildSimpleStringFilter'

const SellerFilter = buildSimpleStringFilter({
  key: 'storefront',
  expandedOnInit: true,
  sortOrder: 'column',
})

export default SellerFilter
